import React, { useEffect, useState } from 'react';
import { Form, Input, Button, Space, Upload, Col, Row, Select, Card, DatePicker, Spin } from 'antd';
import '../../style/page.css'
import { useDispatch, useSelector } from 'react-redux';
import { getAllSubscription } from '../../feature/subscription/subscriptionSlice';
import { ArrowLeft } from 'lucide-react';
import { addDaycare, getDaycare } from '../../feature/dayCare/dayCareSlice';
import { useNavigate, useParams } from 'react-router-dom';
import { CKEditor } from '@ckeditor/ckeditor5-react';
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
import { getCmsData, getCmsDataObject } from '../../constant/Constatnt';
import { addPrivacy, editPrivacy, getPrivacy, getPrivacyById } from '../../feature/cms/PrivacySlice';
import { addTerms, editTerms, getTermsById } from '../../feature/cms/TermSlice';
import { addAboutus, editAboutus, getAboutusById } from '../../feature/cms/AboutSlice';

function EditCmsData() {
    const [descriptions, setDescriptions] = useState(null)
    const { type, id } = useParams()

    const { termsById, isLoading: privacyLoading } = useSelector((state) => state.terms);
    const { privacyById, isLoading: termsLoading } = useSelector((state) => state.privacies);
    const { aboutById, isLoading: aboutLoading } = useSelector((state) => state.abouts);
    const { actionLoader: privacyAction } = useSelector((state) => state.privacies);
    const { actionLoader: termAction } = useSelector((state) => state.terms);
    const { actionLoader: aboutAction } = useSelector((state) => state.abouts);
    const [form] = Form.useForm();
    const dispatch = useDispatch()
    const navigate = useNavigate()

    console.log("termById", termsById)
    console.log("privacyById", privacyById)
    console.log("aboutById", aboutById)

    const fetchCmsDetails = () => {
        if (type === "privacy-policy") {
            dispatch(getPrivacyById(id));
        } else if (type === "terms-conditions") {
            dispatch(getTermsById(id))
        } else {
            dispatch(getAboutusById(id))
        }
    }

    useEffect(() => {
        fetchCmsDetails()
    }, [])

    const onFinish = async () => {
        const bodyTerm = {
            termConditionId: id,
            description: descriptions
        };
        const bodyPolicy = {
            privacyPolicyId: id,
            description: descriptions
        };
        const bodyAbout = {
            aboutUsId: id,
            description: descriptions
        };
        let action;

        if (type === "privacy-policy") {
            action = editPrivacy(bodyPolicy);
        } else if (type === "terms-conditions") {
            action = editTerms(bodyTerm);
        } else {
            action = editAboutus(bodyAbout);
        }

        const resultAction = await dispatch(action);

        if (editPrivacy.fulfilled.match(resultAction) ||
            editTerms.fulfilled.match(resultAction) ||
            editAboutus.fulfilled.match(resultAction)
        ) {
            form.resetFields();
            navigate('/dashboard/cms');
        } else {
            console.error("Error creating CMS");
        }
    };



    const onFinishFailed = (errorInfo) => {
        console.log('Validation Failed:', errorInfo);
    };

    const handleCancel = () => {
        form.resetFields();
    };

    const fetchInitialData = () => {
        let initail;
        if (type === "privacy-policy") {
            initail = privacyById?.description

        } else if (type === "terms-conditions") {
            initail = termsById?.description

        } else {
            initail = aboutById?.description

        }
        return initail
    }

    return (
        <section>
            <Card title={
                <Space>
                    <ArrowLeft onClick={() => navigate(-1)} />
                    <h4 className='cms_add_title'>Edit {type}</h4>
                </Space>
            }>
                {(privacyLoading || termsLoading || aboutLoading) ? <Spin  fullscreen /> : <Form
                    form={form}
                    layout='vertical'
                    onFinish={onFinish}
                    onFinishFailed={onFinishFailed}
                >

                    <Form.Item name="description"
                        label="Description"
                        rules={[
                            {
                                required: false,
                                message: "Please Enter Description!",
                            },
                        ]}>
                        <CKEditor
                            editor={ClassicEditor}
                            data={fetchInitialData()}
                            onChange={(event, editor) => {
                                const data = editor.getData();
                                setDescriptions(data)
                            }}
                            config={{
                                placeholder: "Write here..."
                            }}

                        />

                    </Form.Item>
                    <Form.Item  >
                        <div className='submit_btn'>
                            <Space>
                                <Button type="primary" loading={(privacyAction || termAction || aboutAction)} htmlType="submit">
                                    Submit
                                </Button>
                                <Button danger htmlType="button" onClick={handleCancel}>
                                    Reset
                                </Button>
                            </Space>
                        </div>
                    </Form.Item>
                </Form>}
            </Card>
        </section>
    );
}




export default EditCmsData